module.exports = __webpack_public_path__ + "b7b5ab117f395b5e1050fa4199b863c3.png";